import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import React from "react";
import { usePlayerStats } from "../../contexts/PlayerStatsContext";
import { GameEventType } from "./GameEvent";
import { getEventPlayers } from "./ufaApi";

interface Props {
  ev: any;
  idx: number;
}

export default function EventAccordion({ ev, idx }: Props) {
  const { getPlayerName } = usePlayerStats();
  const evName = ev.eventType && GameEventType[ev.eventType];
  const timestamp = ev.timestamp || ev.time || ev.ts || ev.createdAt || "";
  const players = getEventPlayers(ev) || [];
  const playersText = players
    .map((p) => {
      const display =
        getPlayerName(p.name, { full: true }) || p.name || "unknown";
      return `${display} ${p.action}`;
    })
    .join(" ");

  return (
    <Accordion key={idx} TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600 }}
            >{`${idx + 1}. ${ev.teamId || "unknown team"}`}</Typography>
            <Typography variant="caption" color="text.secondary">
              {evName} {playersText ? `• ${playersText}` : ""}
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">
            {timestamp}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <List dense>
          <ListItem>
            <ListItemText
              primary={`Type: ${evName}`}
              secondary={
                <>
                  <div>{`Team: ${ev.teamId || ev.team || "unknown"}`}</div>
                  <div>{`Player(s): ${playersText || "-"}`}</div>
                  <div style={{ whiteSpace: "pre-wrap", marginTop: 8 }}>
                    {JSON.stringify(ev, null, 2)}
                  </div>
                </>
              }
            />
          </ListItem>
        </List>
      </AccordionDetails>
    </Accordion>
  );
}
